const messages = {
  name: 'Credit Balance |||| Credit Balances',
  fields: {
    costCenter: 'Cost Center',
    costCenterName: 'Cost Center',
    availableCredits: 'Available Credits',
    reservedCredits: 'Reserved Credits',
    blocked: 'Blocked',
    amount: 'Credit Amount',
    newBalance: 'New available balance',
  },
  columns: {
    actions: 'Actions',
    status: 'Status',
  },
  filters: {
    costCenterName: 'Cost Center',
  },
  status: {
    active: 'Active',
    blocked: 'Blocked',
  },
  actions: {
    creditPurchase: 'Credit Purchase',
    topUp: 'Top Up',
    adjust: 'Adjust balance',
    block: 'Block',
    unblock: 'Unblock',
  },
  dialog: {
    purchaseTitle: 'Credit Purchase',
    topUpTitle: 'Top-Up Credits',
    adjustTitle: 'Adjust balance',
    noEligibleCostCenters: 'All cost centers already have a balance. Use Top up (row menu) to add credits.',
  },
  validation: {
    costCenterRequired: 'Cost Center is required',
    amountRequired: 'Credit Amount is required',
    amountMin: 'Amount must be at least 1',
  },
  notifications: {
    purchaseSucceeded: 'Credits added successfully',
    purchaseFailed: 'Failed to add credits',
    blockSucceeded: 'Balance blocked',
    blockFailed: 'Failed to block balance',
    unblockSucceeded: 'Balance unblocked',
    unblockFailed: 'Failed to unblock balance',
    loadCostCentersFailed: 'Failed to load cost centers',
  },
};

export default messages;
